import {
  getFirstMatchingTag,
  ogTwitterImage
} from 'src/components/pageMeta/ImageMappingHandler';
import { getPage } from 'src/components/pageMeta/SchemaDataCreation';

import { CountryCode, DisplayLanguage } from './constants/stringConstants';
import {
  BASE_URL,
  FACEBOOK_APP_ID,
  META_OG_SITE_NAME,
  META_OG_TWITTER_CARD,
  META_OG_TWITTER_CARD_PLAY_COLLECTION,
  META_OG_TWITTER_SITE,
  META_OG_TYPE,
  SPLASH_IMAGE_URL
} from './constants/utilConstants';

export const createOgTags = (
  apiData: any,
  pathname: string,
  isConsumption: boolean,
  translation: string,
  countryCode: string
) => {
  let imageUrl = '';

  if (isConsumption) {
    const pathnameArray = pathname.split('/');
    if (apiData && apiData.tags) {
      const tagName =
        (pathname.match(/live-tv/g) || pathname.match(/tv-channels/g)) &&
        pathnameArray.length === 4
          ? 'channels'
          : getFirstMatchingTag(apiData.tags);

      if (tagName) {
        imageUrl =
          ogTwitterImage(getPage(pathname), apiData) || SPLASH_IMAGE_URL;
      }
    }
    if (
      imageUrl === '' &&
      ((pathname.includes('/live-tv') && pathnameArray.length === 4) ||
        pathname.includes('/news/'))
    ) {
      imageUrl = `${BASE_URL}/images/zee5News.png`;
    }
  } else {
    imageUrl = SPLASH_IMAGE_URL;
  }

  const ogUrl = pathname ? getURL(countryCode, translation, pathname) : '';

  const play5UrlRegex = /(0-8-5161|0-8-4928|0-8-4724|0-8-5162|0-8-2464)/;

  const twitterCard =
    pathname?.match(play5UrlRegex) ||
    pathname?.includes('/channels/details') ||
    pathname?.includes('/tv-shows/tv-channels') ||
    pathname?.includes('/tv-shows/tv-channels/')
      ? META_OG_TWITTER_CARD_PLAY_COLLECTION
      : META_OG_TWITTER_CARD;

  const ogMetaTagsObj = {
    ogTitle: apiData?.original_title ?? '',
    ogImage: imageUrl,
    ogType: META_OG_TYPE,
    ogSiteName: META_OG_SITE_NAME,
    ogDescription: apiData?.description ?? '',
    ogUrl,
    fbId: FACEBOOK_APP_ID,
    twitterCard,
    twitterSite: META_OG_TWITTER_SITE,
    twitterTitle: apiData?.original_title ?? '',
    twitterImage: imageUrl
  };
  return ogMetaTagsObj;
};

export const getURL = (
  countryCode: string,
  translation: string,
  url: string
) => {
  return `${BASE_URL}${generatePathName({
    countryCode,
    translation,
    url
  })}`;
};

//Index.js
export const getBasePathname = (url: string) => {
  // Remove country and translation from the URL
  const tempURLArray = url.split('/');
  tempURLArray.shift();
  if (
    tempURLArray[0] &&
    (tempURLArray[0] === CountryCode.GLOBAL || tempURLArray[0].length === 2)
  ) {
    tempURLArray.shift();
  }
  //remove language
  if (tempURLArray[0] && tempURLArray[0].length === 2) {
    tempURLArray.shift();
  }
  url = `/${tempURLArray.join('/')}`;
  url = url.replace('//', '/');
  return url;
};

//Index.js
type generatePathNameProps = {
  countryCode: string;
  translation: string;
  url: string;
  searchBot?: boolean;
  originalUrl?: string;
};

export const generatePathName = ({
  countryCode,
  translation,
  url = '/',
  searchBot = false,
  originalUrl = '/'
}: generatePathNameProps) => {
  // Adds country and translation to the given pathname
  url = getBasePathname(url);
  const routesArray = [];
  let pathname = '';

  if (
    searchBot &&
    originalUrl.startsWith('/global') &&
    countryCode !== CountryCode.IN
  ) {
    pathname = originalUrl.replace('//', '/');
    return pathname;
  }

  if (countryCode !== CountryCode.IN && !searchBot) {
    routesArray.push(CountryCode.GLOBAL);
  }
  if (translation !== DisplayLanguage.ENGLISH) {
    routesArray.push(translation);
  }

  pathname = `/${routesArray.join('/')}${url}`;
  pathname = pathname.replace(/\/{2}/g, '/');

  if (pathname !== '/' && pathname[pathname.length - 1] === '/') {
    pathname = pathname.substring(0, pathname.length - 1);
  }
  return pathname;
};

// Global Episodes Id for Ladies and Gentlemen Show
export const GLOBAL_LADIES_AND_GENTLEMEN_EPISODES = [
  '0-1-531281',
  '0-1-531283',
  '0-1-531284',
  '0-1-531285',
  '0-1-531286',
  '0-1-531287',
  '0-1-531288',
  '0-1-531289'
];
// India Episodes Id for Ladies and Gentlemen Show
export const INDIA_LADIES_AND_GENTLEMEN_EPISODES = [
  '0-1-531290',
  '0-1-531291',
  '0-1-531292',
  '0-1-531293',
  '0-1-531294',
  '0-1-531295',
  '0-1-531296',
  '0-1-531297'
];

// Country for Ladies and Gentlemen Show
export const LADIES_AND_GENTLEMEN_COUNTRIES = [
  // 'x-default',
  'en-us',
  'en-gb',
  'en-ae',
  'en-ca',
  'en-bd',
  'en-au',
  'en-sg',
  // 'en-in',
  'en-my',
  'en-sa',
  'en-qa',
  'en-de',
  'en-kw',
  'en-id',
  'en-om',
  'en-lk'
];

// Function for returning index of current episode
export const getEpisodeIndex = (episodeId: string, country: string) => {
  return country.toLowerCase() !== CountryCode.IN.toLowerCase()
    ? GLOBAL_LADIES_AND_GENTLEMEN_EPISODES.indexOf(episodeId)
    : INDIA_LADIES_AND_GENTLEMEN_EPISODES.indexOf(episodeId);
};

export const getOGTitle = (ogUrl: string, lang: string, title: string) => {
  //NOTE: for live-tv |ZEE5 is used or appended why?
  return ogUrl.includes(`${process.env.NEXT_PUBLIC_CHANNELCONSUMPTION}/`) &&
    lang !== DisplayLanguage.ENGLISH
    ? title.split('| ZEE5')[0].concat('| ZEE5')
    : title;
};
